import { urlBaseApi } from '../consts';



export const create = (token, body) => {
  return {
    url: `${urlBaseApi}/task/create`,
    method: 'POST',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const list = (token,page,limit) => {
  return {
    url: `${urlBaseApi}/task/get-all?page=${page}&limit=${limit}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const screenshotlist = (token,id) => {
  return {
    url: `${urlBaseApi}/task/screenshots/${id}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const changeTaskPaymentStatus = (token,id,status) => {
  return {
    url: `${urlBaseApi}/task/update-status/${id}`,
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token
    },
    data: {status: status}
  };
};

export const one = (token, id) => {
  return {
     url: `${urlBaseApi}/task/get/${id}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const changeTaskStatus = (token, id, body) => {
  return {
     url: `${urlBaseApi}/task/update-task-status/${id}`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const update = (token, id, body) => {
  return {
    url: `${urlBaseApi}/task/update/${id}`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const remove = (token,id) => {
  return {
    url: `${urlBaseApi}/task/delete/${id}`,
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};